import UserActivityListingPage from '.'

export default function UserActivityListingPageWebWrapper() {
  return <UserActivityListingPage />
}
